import { Controller } from "@hotwired/stimulus"
import toastr from "toastr"

export default class extends Controller {
  static values = {
    type: String,
    message: String
  }

  connect() {
    if (!this.hasMessageValue) return

    if (this.typeValue === "notice" || this.typeValue === "success") {
      toastr.success(this.messageValue)
    } else if (this.typeValue === "alert" || this.typeValue === "error") {
      toastr.error(this.messageValue)
    } else if (this.typeValue === "warning") {
      toastr.warning(this.messageValue)
    } else {
      toastr.info(this.messageValue)
    }

    this.element.remove() // Remove flash element after showing toast
  }
}
